import { FormMarcas } from '../types';

export const formMarcasBlank: FormMarcas = {
  cod_marca: undefined,
  des_marca: '',
  produtos: [],
};
